import React, { useEffect, useState } from 'react';
import { Cascader, Form, message } from 'antd';
import request from '../../../../request';
import {
	API_VEHICLE_BRAND_LIST_NEW,
	API_VEHICLE_SERIES_LIST_NEW,
	API_VEHICLE_VEHICLE_LIST_NEW,
} from '../../../../hooks/carRental/_';

interface PropsType {
	enums?: any;
	isRequired?: any;
	storeCode?: string;
}

const MyCascader: React.FC<PropsType> = props => {
	const { isRequired, storeCode } = props;
	const [options, setOptions] = useState([
		{
			value: '',
			label: '',
			children: [
				{
					value: '',
					label: '',
					children: [
						{
							value: '',
							label: '',
						},
					],
				},
			],
		},
	]);

	// 查询品牌列表
	const queryBrandList = () => {
		request({
			url: API_VEHICLE_BRAND_LIST_NEW,
			method: 'GET',
			params: {
				store_code: storeCode || undefined,
			},
		})
			.then((res: any) => {
				if (!res.data || !res.data.length) {
					setOptions([]);
					return;
				}
				const list: any = [];
				res.data.forEach((brand: any) => {
					const params = {
						label: brand.brand_name,
						value: brand.brand_id,
						isLeaf: false,
					};
					list.push(params);
				});
				setOptions(list);
			})
			.catch(err => {
				message.error(err.message || '查询品牌列表失败');
			});
	};

	// 查询车系列表
	const querySeriesList = (id: string) => {
		return request({
			url: API_VEHICLE_SERIES_LIST_NEW,
			method: 'GET',
			params: {
				brand_id: id,
			},
		});
	};

	// 查询车型年款列表
	const queryVehicleList = (id: string) => {
		return request({
			url: API_VEHICLE_VEHICLE_LIST_NEW,
			method: 'GET',
			params: {
				series_id: id,
			},
		});
	};

	// 去重
	const getFilteredList = (arr: any) => {
		const filteredList = arr.reduce((acc: any, current: any) => {
			const x = acc.find((item: any) => item.vehicle_id === current.vehicle_id);
			if (!x) {
				return acc.concat([current]);
			} else {
				return acc;
			}
		}, []);
		return filteredList;
	};

	// 动态加载级联选择器数据
	const loadData = async (selectedOptions: any) => {
		const targetOption = selectedOptions[selectedOptions.length - 1];
		if (!targetOption.value) return;
		targetOption.loading = true;
		if (!selectedOptions[1]) {
			// 加载二级菜单
			targetOption.loading = false;
			targetOption.children = [];
			const currData: any = await querySeriesList(targetOption.value);
			if (!currData || !currData.data.length) {
				targetOption.isLeaf = true;
			} else {
				const list: any = [];
				currData.data.forEach((series: any) => {
					const params = {
						label: series.series_name,
						value: series.series_id,
						isLeaf: false,
					};
					list.push(params);
				});
				targetOption.children = list;
			}
		} else {
			// 加载三级菜单
			targetOption.children = [];
			targetOption.loading = false;
			const currData: any = await queryVehicleList(targetOption.value);
			if (!currData || !currData.data.length) {
				targetOption.isLeaf = true;
			} else {
				const list: any = [];
				const filteredList = getFilteredList(currData.data);
				filteredList.forEach((vehicle: any) => {
					const params = {
						label: vehicle.vehicle_name,
						value: vehicle.vehicle_id,
					};
					list.push(params);
				});
				targetOption.children = list;
			}
		}
		setOptions([...options]);
	};

	useEffect(() => {
		queryBrandList();
	}, []);

	const searchFormFields = {
		chexing: {
			name: 'vehicle_id',
			label: '车型',
			required: isRequired,
			message: '请选择车型',
			placeholder: '请输入',
		},
	};

	return (
		<Form.Item
			name={searchFormFields.chexing.name}
			label={searchFormFields.chexing.label}
			rules={[
				{
					required: searchFormFields.chexing.required,
					message: searchFormFields.chexing.message,
				},
			]}
		>
			<Cascader
				loadData={loadData}
				options={options}
				changeOnSelect
				allowClear
				placeholder="品牌-车系-车型年款"
			/>
		</Form.Item>
	);
};

export default MyCascader;
